import { useEffect } from 'react';
import StatisticsService from '../../../services/StatisticsService';

export const useTrackExternalReferrer = ({ productCode, shopUuid, months, basket }) => {
    useEffect(() => {
        const referrer = document.referrer;
        const currentOrigin = window.location.origin;


        if (!referrer || !referrer.startsWith(currentOrigin)) {

            const trackVisit = async () => {
                try {
                    await StatisticsService.rentalFormEntered({
                        productCodeBase64: productCode,
                        shopUuid: shopUuid,
                        months: months || '24',
                        ref: referrer || (basket === 'basket' ? 'https://vibe.pl' : null)
                    })();

                } catch (error) {
                    console.error('Błąd podczas wysyłania statystyk:', error);
                }
            };

            trackVisit();
        }
    }, [productCode, shopUuid, months, basket]);
};
